export default __webpack_public_path__ + "static/media/osrcg15_1.fd8e6ebf.png";